import 'regenerator-runtime/runtime'

/**
 * These are actions done by a player
 * every method should return a Promise
 *
 * this refers to the player the actions are being called on
 * @abstract
 */
export default class PlayerActions {
	/**
	 * If I can, do it!
	 * @param dice
	 * @return {Promise.<boolean>}
	 */
	async add2ToRoll(dice) {
		return this.canAdd2ToRoll(dice)
	}

	/**
	 * If I can, do it!
	 * @return {Promise.<boolean>}
	 */
	async rollAgain() {
		return this.canRollAgain()
	}

	/**
	 * If I can, do it!
	 * @param {number[]} dice
	 * @return {Promise.<boolean>}
	 */
	async turnAgain(dice) {
		return this.canTurnAgain(dice)
	}

	/**
	 * If I can, do it!
	 * @return {Promise.<boolean>}
	 */
	async roll2Dice() {
		return this.canRoll2Dice()
	}

	/**
	 * Can I buy landmarks?
	 * By default this will buy anything it can spend money on. (Not good strategy)
	 * @return {Promise.<string[]>}
	 */
	async buyLandmarks() {
		const ret = this.possibleLandmarks()

		while(ret.length && !this.canBuyLandmarks(ret))
			ret.pop()

		return ret.map(lm => lm.name)
	}

	/**
	 * Can I buy from market?
	 * By default this will buy anything it can spend money on. (Not good strategy)
	 * @return {Promise.<number[]>}
	 */
	buyFromMarket(market) {
		const ret = this.possibleCards(market)

		while(ret.length && !this.canBuyCards(ret.map(i => market[i])))
			ret.pop()

		return ret
	}
}